import { render } from "./Fleet.vue?vue&type=template&id=45e23677"
import script from "./Fleet.vue?vue&type=script&lang=js"
export * from "./Fleet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Fleet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45e23677"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45e23677', __exports__)) {
    api.reload('45e23677', __exports__)
  }
  
  module.hot.accept("./Fleet.vue?vue&type=template&id=45e23677", () => {
    api.rerender('45e23677', render)
  })

}


export default __exports__